// extracted by mini-css-extract-plugin
export var container = "_7v-0";
export var error = "_7v-9";
export var label = "_7v-5";
export var light = "_7v-6";
export var md = "_7v-3";
export var sm = "_7v-2";
export var thin = "_7v-8";
export var thinBold = "_7v-7";
export var vertical = "_7v-4";
export var xs = "_7v-1";